import { Tag, Tooltip } from "antd";

const FamilyMembersList = ({ familyData }) => {
  return (
    <div>
      <Tooltip
        color="var(--primary-background)"
        className="family-tooltip"
        style={{ backgroundColor: "white" }}
        title={() => {
          return (
            <div>
              {familyData.adults.length > 0 && (
                <div>
                  {familyData.adults?.map((adult) => {
                    return (
                      <div key={adult.id}>
                        Adult: {adult?.name} ({adult?.membershipNumber})
                      </div>
                    );
                  })}
                </div>
              )}
              {familyData.children.length > 0 && (
                <div>
                  {familyData.children?.map((child) => {
                    return (
                      <div key={child.id}>
                        Child: {child?.name}
                        {child?.membershipNumber
                          ? ` (${child?.membershipNumber})`
                          : ""}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        }}
      >
        <Tag color="success">Family</Tag>
      </Tooltip>
    </div>
  );
};

export default FamilyMembersList;
